import { useQuery } from '@tanstack/react-query'

import { useAuthStore } from '@/stores/authStore'

import { payslipApi } from '../api/payslipApi'

export const payslipKeys = {
  meus: () => ['payslips', 'meus'] as const,
}

/**
 * Contracheques do colaborador logado, via `GET /meus-contracheques`. O id do usuário entra
 * na chave só para o cache não vazar entre sessões de pessoas diferentes no mesmo navegador.
 */
export function usePayslips() {
  const colaboradorId = useAuthStore((state) => state.user?.colaboradorId)
  return useQuery({
    queryKey: [...payslipKeys.meus(), colaboradorId],
    queryFn: payslipApi.listMine,
    enabled: !!colaboradorId,
  })
}
